module.exports = __webpack_public_path__ + "static/media/ana_maria_l.99287b3d.jpg";